export const GMAPS_API_KEY = process.env.REACT_APP_GMAPS_API_KEY || "AIzaSyAOyNvYDzqdx0gAwVovKwsFchhksM2HRWQ";
export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY || "pk_test_K2qzkRGKvDfyIDq28aRuJtjp00i9QOz6l7";
export const BANKART_API_KEY = process.env.REACT_APP_BANKART_API_KEY || "izkwxrFBsZrkuPALWU5w";
export const CAPTCHA_SITE_KEY = process.env.REACT_APP_CAPTCHA_SITE_KEY || "6LffC0AqAAAAANUDnjhGcBHmKdr9xIaFFQl-axgs";
export const RECAPTCHA_ENTERPRISE_SITE_KEY = process.env.REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY || "6Ld9w-8sAAAAAJ3fxOgupPL1gBR9NhoW0Ei03HE5";

export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyBNJNItZZA1cvXYAHuWC9e-QZAOwTT8lTo",
  authDomain: "maps-int-84120705.firebaseapp.com",
  projectId: "maps-int-84120705",
  storageBucket: "maps-int-84120705.firebasestorage.app",
  messagingSenderId: "450062273268",
  appId: "1:450062273268:web:21d1281e8ee053185f6ca1",
  measurementId: "G-LDRZ32PHDE"
};

// Feature flags
export const ALLOW_DIFFERENT_BILLING_ADDRESS = false;  // Allow selecting "druga oseba" for card payment billing
